import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Tooltip extends Component {
  static propTypes = {
    content: PropTypes.node,
    children: PropTypes.node,
    pageX: PropTypes.number,
    pageY: PropTypes.number,
    middle: PropTypes.bool
  };

  static defaultProps = {
    pageX: 0,
    pageY: 0,
    show: false,
    middle: false
  };

  render() {
    const { pageX, pageY, show, middle } = this.props;

    return (
      <div
        className={`tooltip ${show ? 'show' : 'hide'}`}
        style={{
          left: pageX,
          top: pageY,
          ...(middle ? { transform: 'translateX(-50%)' } : {})
        }}
      >
        {this.props.content || this.props.children}
        <style jsx>{`
          .tooltip {
            background: rgba(0, 0, 0, 0.8);
            border-radius: 3px;
            color: white;
            font-size: 12px;
            letter-spacing: 0.5px;
            margin-top: -31px;
            padding: 5px 12px;
            pointer-events: none;
            position: absolute;
            text-transform: uppercase;
            transition: opacity 300ms;
            z-index: 1000;
            white-space: nowrap;
          }
          .tooltip.hide {
            opacity: 0;
          }
          .tooltip.show {
            opacity: 1;
          }
        `}</style>
      </div>
    );
  }
}
